module.exports = __webpack_public_path__ + "img/image-thumb-15.7b16773f.webp";